import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "visible", "rename", "label", "panel"];
import { useEffect, memo } from 'react';
import { Input, useStore } from 'react-login-page';
import { IconEmail } from '../../icons/email';
import { jsx as _jsx } from "react/jsx-runtime";
export var Email = /*#__PURE__*/memo(props => {
  var {
      keyname = 'email',
      name,
      visible = true,
      rename,
      label,
      panel = 'login'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    dispatch
  } = useStore();
  if (!elmProps.children && visible) {
    elmProps.children = IconEmail;
  }
  var key = keyname || name;
  var nameBase = name || rename || keyname;
  useEffect(() => dispatch({
    ["$$" + panel + key]: label
  }), [label]);
  return /*#__PURE__*/_jsx(Input, _extends({
    placeholder: "Your Email",
    spellCheck: false,
    visible: visible,
    index: 1
  }, elmProps, {
    name: nameBase,
    keyname: "$$" + panel + key
  }));
});
Email.displayName = 'Login.Email';